/** Keep device classification stable when rotating or opening the keyboard. */
export function isMobileWebDevice(userAgent: string, maxTouchPoints = 0): boolean {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && maxTouchPoints > 1);
}

export function isMobileWebTestRequested(search: string, enabled: boolean): boolean {
  return enabled && new URLSearchParams(search).get('intersectMobileWeb') === '1';
}

export function getMobileWebDiagnosticsOptions(mobile: boolean, search: string, enabled: boolean) {
  return {
    enabled: enabled && (mobile || isMobileWebTestRequested(search, enabled)),
    // Isolate UPC voice startup only on the mobile pilot; normal entry keeps voice.
    voiceDisabled: enabled && mobile && new URLSearchParams(search).get('intersectVoice') === 'off',
  };
}

/** Trusted event/admin or deployment configuration; never take player URLs from visitor input. */
export function resolveIntersectUpcUrl(desktopUrl: string, mobilePilot: boolean, mobileUrl?: string): string {
  if (!mobilePilot || !mobileUrl) return desktopUrl;
  try {
    const url = new URL(mobileUrl);
    if (url.protocol === 'https:' && !url.username && !url.password && !url.search && !url.hash) {
      return url.href.replace(/\/$/, '');
    }
  } catch (_) { /* Keep the ordinary configured UPC if the override is invalid. */ }
  return desktopUrl;
}

/** World overrides are WebGL streaming manifests, separate from native iOS content. */
export function resolveIntersectWorldUrl(desktopUrl: string, mobile: boolean, mobileUrl?: string): string {
  if (!mobile || !mobileUrl) return desktopUrl;
  try {
    if (!new URL(mobileUrl).pathname.endsWith('/world.streaming.json')) return desktopUrl;
  } catch (_) { return desktopUrl; }
  return resolveIntersectUpcUrl(desktopUrl, mobile, mobileUrl);
}

export function resolveIntersectEntry(mobile: boolean, hasWebGPU: boolean, levelOneEnabled: boolean, mobileWebEnabled: boolean) {
  const fullExperience = hasWebGPU && (!mobile || mobileWebEnabled);
  return {
    connect: levelOneEnabled || fullExperience,
    initialExperienceLevel: (fullExperience ? 2 : 1) as 1 | 2,
    canSwitchExperience: levelOneEnabled && fullExperience,
    legacyMobileFallback: !levelOneEnabled && mobile && !fullExperience,
    legacyDesktopFallback: !levelOneEnabled && !mobile && !hasWebGPU,
  };
}
